import { VueReCaptcha } from 'vue-recaptcha-v3';

// https://dev.to/fitrakun/integrating-nuxt-3-with-recaptcha-v3-for-token-handling-2dp0
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  const options = {
    siteKey: config.public.recaptchaKey,
    loaderOptions: {
      autoHideBadge: true,
      useRecaptchaNet: true,
      renderParameters: {
        hl: 'id',
      },
    },
  };

  nuxtApp.vueApp.use(VueReCaptcha, options);
});
